export class IconPrepender {

    private _map: [string, string[]][];

    constructor(elemToIconClassMap: [string, string[]][]) {
        this._map = elemToIconClassMap;
    }

    private updateListElements(rootElem: HTMLElement): void {
        // Note: Using normal for loop for browser compatibility
        const listElems = rootElem.getElementsByTagName('li');
        for ( var i = 0; i < listElems.length; ++i ) {
            const listElem = listElems[i];
            const node = listElem.firstChild;

            if ( node ) {
                const isTextElement = node.nodeType == 3;

                if ( isTextElement ) {
                    const newP = document.createElement('p');
                    newP.classList.add('force-inline');
                    newP.appendChild(node);
                    listElem.appendChild(newP);
                }
                else {
                    const nodeElem = node as HTMLElement;
                    nodeElem.classList.add('force-inline');
                }
            }
        }
    }

    private createIcon(classes:string[]): HTMLElement {
        const icon = document.createElement('i');
        for ( let c of classes )
            icon.classList.add(c);
        return icon;
    }

    prepend(rootElementId: string): void {
        const rootElems = document.getElementsByClassName(rootElementId);

        for ( var i = 0; i < rootElems.length; ++i ) {
            const rootElem = rootElems[i] as HTMLElement;

            for ( let mapping of this._map ) {
                const divQuery = `div.${mapping[0]}`;
                const pQuery = `p.${mapping[0]}`;
                const divAndPElems = rootElem.querySelectorAll(`${divQuery}, ${pQuery}`);

                for ( var i = 0; i < divAndPElems.length; ++i ) {
                    const additionalClasses = mapping[1];
                    const icon = this.createIcon(['icon', 'dark'].concat(additionalClasses));
                    divAndPElems[i].prepend(icon);
                }
            }

            this.updateListElements(rootElem);
        }
    }

}